<template>
  <b-container fluid>

    <b-row>
      <b-col lg="6" class="my-1">
        <b-form inline>

          <b-form-select v-model="selectedReferrerMonthUsage" :options="optionsReferrerMonthUsage"/>
          <b-button variant="info" @click="exportReportAgency">Download
            <b-spinner v-if="downloadReferrerMonthUsage" small :variant="'danger'"
                       :key="'info'" label="Loading..."></b-spinner>
          </b-button>
        </b-form>
      </b-col>

      <b-col lg="6" class="my-1">
        <!--        <b-form-group-->
        <!--          label="Initial sort"-->
        <!--          label-cols-sm="3"-->
        <!--          label-align-sm="right"-->
        <!--          label-size="sm"-->
        <!--          label-for="initialSortSelect"-->
        <!--          class="mb-0"-->
        <!--        >-->
        <!--          <b-form-select-->
        <!--            v-model="sortDirection"-->
        <!--            id="initialSortSelect"-->
        <!--            size="sm"-->
        <!--            :options="['asc', 'desc', 'last']"-->
        <!--          ></b-form-select>-->
        <!--        </b-form-group>-->
      </b-col>

      <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button size="lg" variant="dark" :disabled="!filter" @click="filter = ''">Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="6" class="my-1">

        <b-form-group
          label="Filter On"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          description="Leave all unchecked to filter on all data"
          class="mb-0">
          <b-form-checkbox-group v-model="filterOn" class="mt-1">
            <b-form-checkbox value="Username">Username</b-form-checkbox>
            <b-form-checkbox value="email">Email</b-form-checkbox>
            <b-form-checkbox value="custom:email_linkedin">LinkedIn Email</b-form-checkbox>
            <b-form-checkbox value="custom:isBlocked">Is Blocked?</b-form-checkbox>
            <b-form-checkbox value="custom:haveAccount">Is LinkedIn Sync?</b-form-checkbox>
            <b-form-checkbox value="SumActiveConfiguration">Active Configuration?</b-form-checkbox>
          </b-form-checkbox-group>

        </b-form-group>
        <div>

        </div>
      </b-col>

      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="right"
          first-text="⏮"
          prev-text="⏪"
          next-text="⏩"
          last-text="⏭"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <span>Total Result : {{ totalRows }} users</span>
    <b-table
      show-empty
      small
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template v-slot:cell(actions)="row">
        <b-button variant="primary" size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
        <b-button v-if="row.item['custom:isBlocked']==='false'" variant="warning"
                  @click="init_deactivate_user(row.item['Username'])">
          Deactivate
        </b-button>
        <b-button variant="danger"
                  @click="init_delete_user(row.item)">
          Delete
        </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>

          <ul>
            <li v-for="(value, key) in row.item" :key="key">
              <span v-if="key=='report'">
                          <table style="width:100%">
                            <tr>
                              <th>Sum</th>
                              <th>Previous Month</th>
                              <th>Actual Month</th>
                            </tr>
                            <tr>
                              <td>Connections</td>
                              <td>{{ value['-1']['SumNbrConnections'] }}</td>
                              <td>{{ value['1']['SumNbrConnections'] }}</td>
                            </tr>
                            <tr>
                              <td>Messages</td>
                              <td>{{ value['-1']['SumNbrMessages'] }}</td>
                              <td>{{ value['1']['SumNbrMessages'] }}</td>
                            </tr>
                            <tr>
                              <td>Likedposts</td>
                              <td>{{ value['-1']['SumLikedPosts'] }}</td>
                              <td>{{ value['1']['SumLikedPosts'] }}</td>
                            </tr>
                            <tr>
                              <td>Withdraws</td>
                              <td>{{ value['-1']['SumWithdraw'] }}</td>
                              <td>{{ value['1']['SumWithdraw'] }}</td>
                            </tr>
                            <tr>
                              <td>Endorses</td>
                              <td>{{ value['-1']['SumNbrEndorse'] }}</td>
                              <td>{{ value['1']['SumNbrEndorse'] }}</td>
                            </tr>
                          </table>

                 <ul>
                  <b> Active configurations:</b>
                  <li>&emsp;&#8226; Connection:{{ value['connection'] }}</li>
                  <li>&emsp;&#8226; Message:{{ value['message'] }}</li>
                  <li>&emsp;&#8226; GetContactInformation:{{ value['getContactInformation'] }}</li>
                </ul>
                <ul>
                  <b> YourSynchronicity Sync:</b>
                  <li>&emsp;&#8226; Joined YSY  on : {{ value['UserCreated'] }}</li>
                  <li>&emsp;&#8226; LinkedIn Added on : {{ value['link_linkedin'] }}</li>
                </ul>
              </span>
            </li>

          </ul>

        </b-card>
      </template>
    </b-table>

    <b-modal @ok="deactivate_user" ok-title="Yes" @ id="modal-deactivate-user"
             title="Deactivate user">
      <p class="my-4">Are you sure you want to deactivate that user
        {{ this.tmp_user_for_modal_deactivate }}</p>
    </b-modal>
    <b-modal v-bind:ok-disabled="this.deleteConfirmation!=='Delete'"
             title="Delete user"
             header-bg-variant="danger"
             header-text-variant="light"
             @ok="delete_user" ok-title="Yes" @
             id="modal-delete-user">
      <p class="my-4">To confirm the deletion of the user, please type Delete in the box,Are you
        sure you want to delete that user
        {{ this.tmp_user_for_modal_delete }}</p>
      <p class="my-4">This action is not reversible. To confirm the deletion of the user, please
        type <span style="color: red">Delete</span> in the box</p>
      <b-form-input v-model="deleteConfirmation"/>
    </b-modal>
  </b-container>
</template>

<script>
import {refreshIdToken} from '../../util/utilsYsy'

export default {
  name: 'ReferrerUserAdminPanel',
  props: ['referrerUser'],
  data() {
    return {
      downloadReferrerMonthUsage: false,
      selectedReferrerMonthUsage: null,
      items: this.referrerUser,
      stateDeletionUser: true,
      referrer: this.$store.state.referrer,
      optionsReferrerMonthUsage: [{value: null, text: `Export usage of ${this.$store.state.referrer} users`}],
      deleteConfirmation: '',
      tmp_user_for_modal_deactivate: '',
      tmp_user_for_modal_delete: '',
      tmp_email_linkedin_for_modal_delete: '',
      fields: [
        {key: 'Username', label: 'Username', sortable: true, sortDirection: 'desc'},
        {key: 'email', label: 'Email', sortable: true, class: 'text-center'},
        {
          key: 'custom:haveAccount', label: 'LinkedIn Sync?',
          formatter: (value, key, item) => {
            return (!('custom:haveAccount' in item)) ? 'None' : (value === 'true' ? 'Yes' : 'No')
          }, sortable: true, sortByFormatted: true,
          filterByFormatted: true, class: 'text-center'
        },
        {
          key: 'custom:email_linkedin',
          label: 'LinkedIn Email',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'SumActiveConfiguration',
          label: 'Active configurations',
          sortable: true,
          class: 'text-center'
        },
        // {
        //     key: 'custom:automatedYsyActions',
        //     label: 'Automated Ysy Actions?',
        //     formatter: (value, key, item) => {
        //         if ('custom:automatedYsyActions' in item) {
        //             if (value.includes("@YSY@")) {
        //                 return value.split("@YSY@").join(',');
        //             } else {
        //                 return value
        //             }
        //         } else {
        //             return 'None'
        //         }
        //     },
        //     sortable: true,
        //     sortByFormatted: true,
        //     filterByFormatted: true
        // },
        // {key: 'isBlocked', label: 'Is Blocked?', sortable: true, class: 'text-center'},
        {key: 'state', label: 'License Key', class: 'text-center'},
        {
          key: 'custom:isBlocked',
          label: 'Is Blocked?',
          formatter: (value, key, item) => {
            return value === 'true' ? 'Yes' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        {key: 'actions', label: 'Actions'}
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {text: f.label, value: f.key}
        })
    }
  },
  mounted() {
    // Set the initial number of items
    console.log("this.referrerUser", this.referrerUser)
    this.totalRows = this.items.length
  },

  methods: {
    refreshIdToken,
    populateMonthUsage() {
      var theMonths = ["January", "February", "March", "April", "May",
        "June", "July", "August", "September", "October", "November", "December"];
      var today = new Date();
      var aMonth = today.getMonth();
      for (var i = 0; i < aMonth + 1; i++) {
        this.optionsReferrerMonthUsage.push({value: i + 1, text: theMonths[i]})
      }
    },
    async exportReportAgency(report) {
      this.downloadReferrerMonthUsage = true
      const path = this.BACKEND_YSY + "/download-contacts";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          contact_type: "agency_report",
          month_report: this.selectedReferrerMonthUsage,
          download: "true"
        }, {headers})
        .then(res => {
          let fileLink = document.createElement('a');
          console.log('res.data',res.data)
          fileLink.href =res.data;
          document.body.appendChild(fileLink);
          fileLink.click();
          this.downloadReferrerMonthUsage = false
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.exportContact(report)
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async deactivate_user() {
      console.log('Deactivating the following use', this.tmp_user_for_modal_deactivate);
      const path = this.BACKEND_YSY + "/admin/get-licenses-by-referrer";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };

      let payload = {
        username: this.tmp_user_for_modal_deactivate,
        deactivate: 'true'
      };
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log(res);
          this.tmp_user_for_modal_deactivate = '';
          this.$router.go()
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.deactivate_user();
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },

    init_deactivate_user(username) {
      this.tmp_user_for_modal_deactivate = username;
      console.log('the user is ', this.tmp_user_for_modal_deactivate);
      this.$bvModal.show("modal-deactivate-user")
    },
    async delete_user() {
      console.log('Deleting the following user', this.tmp_user_for_modal_delete);
      const path = this.BACKEND_YSY + "/admin/get-licenses-by-referrer";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };

      let payload = {
        username: this.tmp_user_for_modal_delete,
        email_linkedin: this.tmp_email_linkedin_for_modal_delete,
        delete: 'true'
      };
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log(res);
          this.deleteConfirmation = '';
          this.tmp_user_for_modal_delete = '';
          this.tmp_email_linkedin_for_modal_delete = '';
          this.$router.go()
          this.$notify({
            message:
              '<b>Deleting the user ...</b>',
            timeout: 5000,
            icon: 'ni ni-bell-55',
            type: "success"
          });

        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.deactivate_user();
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },

    init_delete_user(item) {
      this.tmp_user_for_modal_delete = item['Username'];
      this.tmp_email_linkedin_for_modal_delete = "custom:email_linkedin" in item ? item["custom:email_linkedin"] : 'NaN';
      console.log('the user is ', this.tmp_user_for_modal_delete, 'email linkedin', this.tmp_email_linkedin_for_modal_delete);
      this.$bvModal.show("modal-delete-user")
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  created() {
    this.populateMonthUsage()
  }
}
</script>
